import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageKey, StorageService } from '@zopup/zop-shared';
import { ZopAuthConfigService } from '../../providers/zop-auth-config.provider';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private readonly authConfig = inject(ZopAuthConfigService);

  constructor(
    private router: Router,
    private storageService: StorageService
  ) {}

  /**
   * Stores a redirect URL to be used after authentication
   */
  storeRedirectUrl(url: string): void {
    this.storageService.setItem<string>(StorageKey.redirectUrl, url);
  }

  /**
   * Gets the stored redirect URL and clears it
   */
  getStoredRedirectUrl(): string | null {
    const url = this.storageService.getItem<string>(StorageKey.redirectUrl);
    this.storageService.removeItem(StorageKey.redirectUrl);
    return url;
  }

  /**
   * Navigate to the stored redirect URL or fallback URL
   */
  navigateToStoredUrl(fallbackUrl?: string): void {
    const redirectUrl = this.getStoredRedirectUrl();
    const configuredFallback = this.authConfig.getConfig().fallbackUrls.defaultRedirect;
    const targetUrl = redirectUrl || fallbackUrl || configuredFallback;
    
    // Debug logging
    console.group('🧭 NavigationService.navigateToStoredUrl()');
    console.log('📥 Stored redirect URL:', redirectUrl || 'None');
    console.log('🔄 Fallback URL (param):', fallbackUrl || 'None');
    console.log('⚙️ Configured fallback:', configuredFallback);
    console.log('🎯 Target URL:', targetUrl);
    console.log('📍 Current URL:', this.router.url);
    console.groupEnd();
    
    this.router.navigateByUrl(targetUrl);
  }
}